import { createSlice } from "@reduxjs/toolkit";

const notificationsStatusSlice = createSlice({
  name: "notificationsStatus",
  initialState: {},
  reducers: {
    setNotificationsStatusesData: (_state, action) =>
      action.payload.reduce((prev, curr) => ({ ...prev, [curr.id]: curr }), {}),
  },
});

const unreadNotificationsCountSlice = createSlice({
  name: "unreadNotificationsCount",
  initialState: 0,
  reducers: {
    setUnreadNotificationsCount: (_state, action) => action.payload,
  },
});

const showNotificationSlice = createSlice({
  name: "showNotification",
  initialState: false,
  reducers: {
    setShowNotification: (_state, action) => action.payload,
  },
});

const notificationsDataSlice = createSlice({
  name: "notificationsData",
  initialState: [],
  reducers: {
    setNotificationsData: (_state, action) => action.payload,
    readNotificationsData: (state, action) =>
      state.map((notification) => {
        if (action.payload.indexOf(notification.id) !== -1) {
          notification.read = "NOTIFICATION_READ";
        }
        return notification;
      }),
    unreadNotificationsData: (state, action) =>
      state.map((notification) => {
        if (action.payload.indexOf(notification.id) !== -1) {
          notification.read = "NOTIFICATION_UNREAD";
        }
        return notification;
      }),
  },
});

export const { setNotificationsStatusesData } = notificationsStatusSlice.actions;
export const { setUnreadNotificationsCount } = unreadNotificationsCountSlice.actions;
export const { setShowNotification } = showNotificationSlice.actions;
export const { setNotificationsData, readNotificationsData, unreadNotificationsData } = notificationsDataSlice.actions;

export const notificationsStatus = notificationsStatusSlice.reducer;
export const unreadNotificationsCount = unreadNotificationsCountSlice.reducer;
export const showNotification = showNotificationSlice.reducer;
export const notificationsData = notificationsDataSlice.reducer;

export default {
  notificationsStatus,
  unreadNotificationsCount,
  showNotification,
  notificationsData,
};
